import { schema } from 'normalizr'

export const operatorSchema = new schema.Entity(
  'operators',
  {},
  { idAttribute: 'code' }
)
